(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryConditionDate', {
		bindings: {
			condition: '<',
			operators: '<',
		},
		controller: MxSearchQueryConditionDateCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/by-type/mx-search-query-condition-date.html',
	});

	MxSearchQueryConditionDateCtrl.$inject = ['$scope', '$filter', 'mx.internationalization'];

	function MxSearchQueryConditionDateCtrl($scope, $filter, i18n) {
		var vm = this;
		var watchers = [];

		vm.$onInit = function () {
			vm.showFixedDate = false;

			vm.fromLabel = i18n.get('solutionBuilderAgent.components.mx-search-query-condition-date.from');
			vm.tillLable = i18n.get('solutionBuilderAgent.components.mx-search-query-condition-date.till');
			vm.daysLable = i18n.get('solutionBuilderAgent.components.mx-search-query-condition-date.days');
			vm.minsLable = i18n.get('solutionBuilderAgent.components.mx-search-query-condition-date.mins');
			vm.andLable = i18n.get('solutionBuilderAgent.components.mx-search-query-condition.and');
			vm.todayLable = i18n.get('solutionBuilderAgent.common.today');
			vm.nowLable = i18n.get('solutionBuilderAgent.components.mx-search-query-condition.now');

			vm.fromDays = '0';
			vm.fromSign = '+';
			vm.fromType = 'n';
			vm.tillSign = '+';
			vm.tillType = 'n';
			vm.tillDays = '0';
			vm.fromDatepart = 'd';
			vm.tillDatepart = 'd';
			vm.fromEnabled = false;
			vm.tillEnabled = false;
			setView();

			if (vm.condition) {
				if (!Array.isArray(vm.condition.value) || !vm.condition.value.length) {
					vm.condition.value = ['', ''];
				} else if (vm.condition.value.length > 2) {
					vm.condition.value = [vm.condition.value[0], vm.condition.value[1]];
				}
			}

			if (vm.showFixedDate) {
				var data = parseFlexDate(vm.condition.value[0]);

				if (data !== null) {
					vm.fromEnabled = true;
					vm.fromDays = Math.abs(data[0]);
					vm.fromSign = data[0] < 0 ? '-' : '+';
					vm.fromDatepart = data[2];
					vm.fromType = data[1];
				}

				data = parseFlexDate(vm.condition.value[1]);

				if (data !== null) {
					vm.tillEnabled = true;
					vm.tillDays = Math.abs(data[0]);
					vm.tillSign = data[0] < 0 ? '-' : '+';
					vm.tillDatepart = data[2];
					vm.tillType = data[1];
				}
			}
		};

		watchers.push(
			$scope.$watch('vm.condition.operator', function () {
				setView();
				setValueString();
			})
		);
		watchers.push(
			$scope.$watchGroup(['vm.fromType', 'vm.fromDays', 'vm.fromSign', 'vm.fromEnabled', 'vm.tillEnabled', 'vm.tillDays', 'vm.tillDatepart', 'vm.fromDatepart'], setValues)
		);

		watchers.push($scope.$watchCollection('vm.condition.value', setValueString));
		$scope.$on('$destroy', function () {
			watchers.forEach(function (w) {
				w();
			});
			watchers = [];
		});

		function parseFlexDate(val) {
			if (val) {
				var datePart = 'd';
				var type = 'n';

				if (val.indexOf('m') === 0) {
					datePart = 'm';
					val = val.substring(1);
				}

				if (val.indexOf('t') === 0) {
					type = 't';
					val = val.substring(1);
				}

				if (!val) {
					val = 0;
				}

				if (!isNaN(val)) {
					val = parseInt(val);
					return [val, type, datePart];
				}
			}
			return null;
		}

		function setView() {
			vm.showFixedDate = vm.condition.operator === vm.operators.FlexDateBetween.value;
			if (vm.condition.operator === vm.operators.Between.value) {
				vm.fromEnabled = vm.tillEnabled = true;
				vm.condition.value[0] = vm.condition.value[0] ? new Date(vm.condition.value[0]) : '';
				vm.condition.value[1] = vm.condition.value[1] ? new Date(vm.condition.value[1]) : '';
			}
		}

		function setValues() {
			if (vm.showFixedDate) {
				if (vm.fromEnabled) {
					vm.condition.value[0] = (vm.fromDatepart === 'd' ? '' : 'm') + (vm.fromType === 't' ? 't' : '') + (vm.fromSign === '-' ? -1 : 1) * (vm.fromDays || 0);
				} else {
					vm.condition.value[0] = '';
				}

				if (vm.tillEnabled) {
					vm.condition.value[1] = (vm.tillDatepart === 'd' ? '' : 'm') + (vm.tillType === 't' ? 't' : '') + (vm.tillSign === '-' ? -1 : 1) * (vm.tillDays || 0);
				} else {
					vm.condition.value[1] = '';
				}
			}
		}

		function valueToDisplayString(value) {
			if (value || value === 0) {
				if (vm.showFixedDate) {
					var data = parseFlexDate(value);
					if (!data) {
						return null;
					}
					value = data[1] === 't' ? vm.todayLable : vm.nowLable;

					if (data[0]) {
						value += (data[0] > 0 ? ' +' : ' -') + data[0] + ' ' + (data[2] === 'm' ? vm.minsLable : vm.daysLable);
					}
				} else {
					value = i18n.formatDate(value, 'longDate');
				}
			}
			return value;
		}

		function setValueString() {
			var res = '';

			var from = vm.fromEnabled ? valueToDisplayString(vm.condition.value[0]) : null;
			var till = vm.tillEnabled ? valueToDisplayString(vm.condition.value[1]) : null;

			if (from) {
				res = vm.fromLabel + ' ' + from;
			}

			if (till) {
				if (res) {
					res += ' ';
				}

				res += vm.tillLable + ' ' + till;
			}

			vm.condition.valueString = res;
			var isSetCondition = vm.condition.operator === vm.operators.IsNotSet.value || vm.condition.operator === vm.operators.IsSet.value;
			vm.condition.__valid = vm.fromEnabled || vm.tillEnabled || isSetCondition;
		}

		return vm;
	}
})();
